import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'site-visit-confirmation-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './site-visit-confirmation-dialog.component.html',
  styleUrl: './site-visit-confirmation-dialog.component.scss',
})
export class SiteVisitConfirmationDialogComponent {
  @Input() active = false;

  @Output() modalClose = new EventEmitter<boolean>();

  closeDialog() {
    this.active = false;
    this.modalClose.emit(this.active);
  }
}
